import React, { useMemo } from 'react';

import { notNull } from 'utils/type_guards';
import { formatPrice } from 'utils/common';
import { breakTagRegex } from 'utils/regexes';

export type CartProductLineItemProps = {
  label: string;
  price?: number;
};

function CartProductLineItem(props: CartProductLineItemProps) {
  const { label, price } = props;

  const priceDisplay = useMemo(() => {
    if (notNull(price) && price !== 0) {
      return formatPrice(price, { symbol: '' });
    }

    return <span className="no_price" />;
  }, [price]);

  const formattedLabel = useMemo(() => label.replace(breakTagRegex, ' '), [label]);

  return (
    <tr className="base_price">
      <td width="320">{formattedLabel}</td>
      <td width="80" />
      <td width="96" className="li_price branding">
        {notNull(price) && price !== 0 && <span className="price_prefix">$</span>}
        {priceDisplay}
      </td>
    </tr>
  );
}

export default CartProductLineItem;
